import React from "react"
import { Alert, DisplayValue } from "../../.."
import { Button } from "@mui/material"
import QuestionnaireSelectMultipleField from "../questionnaire/QuestionnaireSelectMulitpleField"
import { store } from "../../../stores/Store"
import { Icons } from "../../../misc/Icons"
import { getMergeSources } from "../questionnaire/merge/mergeUtils"
import MergeReview from "../questionnaire/merge/MergeReview"


export default function AutomationQuestionnaireSelectFormSection ({
    automationOption,
    enquiry,
    hidden = true,
    onCancel = () => {},
    onSubmit = (values) => {}
}) {

    const [loading, setLoading] = React.useState(false)
    const [questionnaireUids, setQuestionnaireUids] = React.useState([])
    const [errorMessage, setErrorMessage] = React.useState(null)
    const [dataSources, setDataSources] = React.useState(null)
    const [relevantTemplateKeys, setRelevantTemplateKeys] = React.useState<string[]>([])

    React.useEffect(() => {
        var _relevantTemplateKeys = store.QuestionnaireStore.setSearchTemplateKeysByAutomationId(automationOption?.id)
        setRelevantTemplateKeys(_relevantTemplateKeys)
        store.QuestionnaireStore.setSearchAccountUids(null)
    }, [automationOption])

    const getDataSources = async () => {
        setLoading(true)
        await getMergeSources(automationOption.id, enquiry?.uid, questionnaireUids).then((dataSourceList) => {
            setDataSources(dataSourceList)
        }).catch((response) => {
            Alert({message: "Failed to source data"})
        })
        setLoading(false)
    }
    
    if (hidden) return <></>

    const qualifyingRule = store.EnquiryStore.getQualifyingRule(enquiry)
    const dependantEnquiryProvisions = ["UK.D.33.2", "UK.D.33.3"]
    const dependantEnquiry = dependantEnquiryProvisions.includes(qualifyingRule)
    const dependantForm = automationOption.id.includes("DEP")
    const subjectPrefix = dependantForm && !dependantEnquiry ? "subject_supporter" : "subject"

    if (dataSources) {
        return (
            <MergeReview
                dataSources={dataSources} 
                onSubmit={(values) => onSubmit(values)} 
                onCancel={() => {
                    store.QuestionnaireStore.setMergeOverride({})
                    setDataSources(null)
                }} />
        )
    }

    return (
        <div className={loading ? "disabled" : ""}>
            {relevantTemplateKeys?.length ? (
                <div>
                    <p>The relevant Questionnaire types for this Automation are:</p>
                    
                    {relevantTemplateKeys.map((key, i) => (
                        <div key={i} style={{display: "flex", marginLeft: "10px", gap: "6px", alignItems: "center", color: "grey"}}>
                            <Icons.Questionnaire style={{fontSize: "14px"}} />
                            <small>{DisplayValue("template_key", key)}</small>
                        </div>
                    ))}

                    <div style={{width: "100%", height: "0.5px", backgroundColor: "#a7a7a7", margin: "10px auto 0", boxSizing: "border-box"}}></div>
                </div>
            ) : null}

            <QuestionnaireSelectMultipleField 
                value={questionnaireUids} 
                onChange={(value) => setQuestionnaireUids(value)} />

            {errorMessage ? <span className="warning">{errorMessage}</span> : null}

            <div className="header" style={{marginTop: "5px"}}>
                <Button 
                    className="btn btn-sm" 
                    onClick={() => {
                        setQuestionnaireUids([])
                        onCancel()
                    }}>
                    Cancel
                </Button>

                <Button
                    color="success"
                    variant="contained"
                    className="btn btn-sm"
                    onClick={() => {
                        if (!enquiry && !questionnaireUids?.length) {
                            setErrorMessage("You must select at least one Questionnaire.")
                        } else {
                            getDataSources()
                        }
                    }}>
                    Continue with selection
                </Button>
            </div>
        </div>
    )
}